export const GET_BIDS = 'Get_Bids';